import React, { useContext } from 'react';
import { useLocation } from 'react-router';
import LSSearch from '@localsearchdev/ls-search-react';
import { Context } from '../context/AppContext';

function useGetPageTypeForDataLayer() {
  const { pathname } = useLocation();
  if (pathname === '/') {
    return 'Home Page';
  }
  return pathname;
}

function SearchBar({
  media,
  positionOnPage = 'Page Header',
  withoutProvider,
  ...props
}) {
  const {
    media: { mobile, tablet },
    user,
  } = useContext(Context);
  const pageType = useGetPageTypeForDataLayer();

  return (
    <LSSearch
      media={media || (mobile || tablet ? 'mobile' : 'desktop')}
      withoutProvider={withoutProvider}
      {...(withoutProvider
        ? {}
        : {
            pageDataLayerValues: {
              userId: user?.user?.id,
              pageType,
              ctaPositionOnPage: positionOnPage,
            },
          })}
      {...props}
    />
  );
}

export default SearchBar;
